import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Label, Container } from 'reactstrap';
import { AvForm, AvGroup, AvInput, AvFeedback, AvField } from 'availity-reactstrap-validation';
import MaterialIcon from 'material-icons-react';
import i18n from '../../i18next';

import { localizeCountryNames } from '../../utils/CommonUtils';
import { countryList } from '../../utils/Constants';

class AdminScreen extends Component {
	constructor(props) {
		super(props);
		this.state = {
			id: -1,
			name: '',
			phone: '',
			email: '',
			password: '',
			repeatPassword: '',
			language: 'en',
			countryCode: '',
			stateAlreadyCopiedFromProps: false
		}

		this.changeState = this.changeState.bind(this);
		this.saveChanges = this.saveChanges.bind(this);
	}

	changeState({ target }) {
		this.setState({ ...this.state.user, [target.name]: target.value });
	}

	manageStateOnRender() {

		if (this.props.isOpen) {
			if (this.props.admin !== undefined && this.props.admin !== null &&
				this.props.admin.id !== undefined && this.props.admin.id !== -1 &&
				!this.state.stateAlreadyCopiedFromProps) {

				this.copyStateFromProps();
			}
		} else {
			this.resetState();
		}
	}

	copyStateFromProps() {

		this.setState(
			{
				id: this.props.admin.id,
				name: this.props.admin.name,
				phone: this.props.admin.phone,
				email: this.props.admin.email,
				countryCode: this.props.admin.countryCode,
				language: this.props.admin.language,
				stateAlreadyCopiedFromProps: true
			}
		);
	}

	resetState() {
		this.state.id = -1;
		this.state.name = '';
		this.state.phone = '';
		this.state.email = '';
		this.state.password = '';
		this.state.repeatPassword = '';
		this.state.language = 'en';
		this.state.stateAlreadyCopiedFromProps = false;
	}

	saveChanges() {
		if (this.state.id === undefined || this.state.id === -1) {

			this.props.onSave(this.state);
			// save
		} else {
			//update
			let regex = /[A-Za-z]/g;
			let isValidPhoneNumber = this.state.phone.match(regex);
			const regexNumbers = /[0-9]/g;
			let newPhone = [];
			this.state.phone.match(regexNumbers).map(singleNumber => {
				newPhone.push(singleNumber);
			});

			if (newPhone > 17) {
				return this.props.dispatchMessage(i18n.t('common:phoneValidation.phoneTooLong'));
			}

			if (isValidPhoneNumber !== null) {
				return this.props.dispatchMessage(i18n.t('common:phoneValidation.invalidPhone'));
			}
			const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();

			// Parse number with country code and keep raw input.
			const number = phoneUtil.parseAndKeepRawInput(this.state.phone, this.state.countryCode);
			let validNumber = phoneUtil.isValidNumberForRegion(number, String(this.state.countryCode));

			if (!validNumber) {
				return this.props.dispatchMessage(i18n.t('common:phoneValidation.phoneMatchFailure'));
			}

			this.props.onUpdate(this.state);
		}
	}

	renderName() {
		return (
			<AvGroup>
				<Label for="name">{i18n.t('common:form.name')}</Label>
				<AvInput
					type="name" name="name" id="name"
					value={this.state.name}
					onChange={this.changeState}
					disabled={this.props.isEventTrackingScreen}
					required />
				<AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
			</AvGroup>
		);
	}

	renderPhone() {
		return (
			<AvGroup>
				<AvField name="phone" label={i18n.t('common:form.phone')} type="text"
					value={this.state.phone}
					onChange={this.changeState}
					disabled={this.props.isEventTrackingScreen}
					required
					errorMessage={i18n.t('common:validations.errorMsg')}
				/>
			</AvGroup>
		);
	}

	renderEmail() {
		return (
			<AvGroup>
				<AvField type="email" name="email" label={i18n.t('common:form.email')}
					value={this.state.email}
					onChange={this.changeState}
					disabled={this.props.isEventTrackingScreen}
					required
					errorMessage={i18n.t('common:validations.errorMsg')}
				// validate={{
				// 	pattern: {
				// 		value: '[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$',
				// 		errorMessage: i18n.t('common:validations.errorMsgEmail')
				// 	}
				// }}
				/>
				<AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
			</AvGroup>
		);
	}

	renderPasswordGroup() {
		const fieldRequired = (this.state.id !== undefined && this.state.id !== -1) ? false : true;

		return (
			<div>
				<AvGroup hidden={this.props.isEventTrackingScreen}>
					<AvField
						type="password" name="password" label={i18n.t('common:form.password')} minLength={6}
						onChange={this.changeState}
						disabled={this.props.isEventTrackingScreen}
						required={fieldRequired}
						errorMessage={i18n.t('common:validations.errorMsg')}
						validate={{
							minLength: {
								value: 6,
								errorMessage: i18n.t('common:validations.passLength')
							}
						}} />
				</AvGroup>
				<AvGroup hidden={this.props.isEventTrackingScreen}>
					<AvField
						type="password" name="repeatPassword" label={i18n.t('common:form.repeatPass')}
						onChange={this.changeState}
						disabled={this.props.isEventTrackingScreen}
						required={fieldRequired}
						errorMessage={i18n.t('common:validations.errorMsg')}
						validate={{
							match: {
								value: 'password',
								errorMessage: i18n.t('common:validations.matchPasswords')
							}
						}} />
				</AvGroup>
			</div>
		);
	}

	renderCountry() {
		return (
			<AvGroup>
				<AvField type="select" name="countryCode" id="country" placeholder={i18n.t('screens:restaurantsScreen.country')} label={i18n.t('screens:restaurantsScreen.country')}
					value={this.state.countryCode}
					errorMessage={i18n.t('common:validations.chooseCountry')}
					disabled={this.props.isEventTrackingScreen}
					required
					onChange={this.changeState}
				>
					<option value="">{i18n.t('screens:generalScreen.chooseOption')}</option>
					{this.renderCountryOptions()}
				</AvField>
			</AvGroup>
		);
	}

	renderCountryOptions() {
		return countryList.map((country, i) => {
			return <option key={i} value={country}>{localizeCountryNames(country)}</option>
		});
	}

	renderLanguages() {
		return (
			<AvGroup>
				<AvField type="select" name="language" id="language" placeholder={i18n.t('common:form.lang')} label={i18n.t('common:form.lang')}
					value={this.state.language}
					disabled={this.props.isEventTrackingScreen}
					errorMessage={i18n.t('common:validations.chooseLanguage')}
					required
				>
					<option value="">{i18n.t('screens:generalScreen.chooseOption')}</option>
					<option value="en">{i18n.t('common:languages.english')}</option>
				</AvField>
			</AvGroup>
		);
	}

	render() {
		const { modalContainer } = styles;
		const { spaceBetween } = this.props.styles;

		this.manageStateOnRender();

		return (
			<div>
				<Modal isOpen={this.props.isOpen} toggle={this.props.onToggle}>
					<AvForm onValidSubmit={this.saveChanges} className="modalForm">
						<ModalHeader className="modalHeader" toggle={this.props.onToggle}>{this.props.isEventTrackingScreen ? i18n.t('screens:adminScreen.user') : i18n.t('screens:adminScreen.heading')}</ModalHeader>
						<ModalBody>
							<Container style={modalContainer}>
								{this.renderName()}
								{this.renderPhone()}
								{this.renderEmail()}
								{this.renderPasswordGroup()}
								{this.renderCountry()}
								{this.renderLanguages()}
							</Container>
						</ModalBody>
						<ModalFooter>
							<Button color="primary" hidden={this.props.isEventTrackingScreen} ><MaterialIcon icon="save" color="#fff" size={18} /><span style={spaceBetween}>{i18n.t('common:buttons.save')}</span></Button>
						</ModalFooter>
					</AvForm>
				</Modal>
			</div>
		);
	}

}

export default AdminScreen;

let styles = {
	modalContainer: {
		backgroundColor: '#f8f8f8',
		paddingTop: 10,
		paddingBottom: 10,
		border: '1px solid #E9ECEF'
	}
};


// WEBPACK FOOTER //
// ./src/components/users/AdminScreen.js